import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-departament',
  templateUrl: './departament.component.html',
  styleUrls: ['./departament.component.scss']
})
export class DepartamentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
